import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/en';
import PropTypes from 'prop-types';

// Ensure dayjs plugins are loaded
dayjs.extend(customParseFormat);
dayjs.locale('en');

export default function MDTimePicker({ 
  label, 
  value, 
  onChange, 
  textFieldProps = {}, 
  displayFormat = 'hh:mm A',
  ...rest 
}) {
  // Parse time string "HH:MM AM/PM" to dayjs object
  const dayjsValue = React.useMemo(() => {
    if (!value) return null;
    try {
      return dayjs(value, 'HH:mm A');
    } catch (e) {
      return null;
    }
  }, [value]);

  // Handle time change - format back to "HH:MM AM/PM"
  const handleTimeChange = (newTime) => {
    if (onChange) {
      if (newTime) {
        const formattedTime = newTime.format('hh:mm A');
        onChange(formattedTime);
      } else {
        onChange('');
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        value={dayjsValue}
        onChange={handleTimeChange}
        ampm={true}
        inputFormat={displayFormat}
        renderInput={(params) => <TextField {...params} size="small" {...textFieldProps} />}
        {...rest}
      />
    </LocalizationProvider>
  );
}

MDTimePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  textFieldProps: PropTypes.object,
  displayFormat: PropTypes.string,
};
